export default __webpack_public_path__ + "static/media/AcceleronsGallery_27.2ab71909.JPG";